<script setup>
import { MessageBus } from '@podium/browser'
import { setConfig, config } from '@finn-no/huck-config'

const messageBus = new MessageBus()

const pushMessages = () => {
  messageBus.publish('classified-innfinn-channel', 'pf-price', 999)
  messageBus.publish('classified-innfinn-channel', 'pf-make', 'MITSUBISHI')
  messageBus.publish('classified-innfinn-channel', 'pf-effect', 180)
  messageBus.publish('classified-innfinn-channel', 'pf-mileage', 99_999)
  messageBus.publish('classified-innfinn-channel', 'pf-year', 2010)
  messageBus.publish('classified-innfinn-channel', 'pf-first-registration', '2010-01-01')
}

const prepToCheckOffer = () => setConfig({ ...config, adId: 1 })
const prepToUncheckOffer = () => setConfig({ ...config, adId: 2 })
const update = () => {
  setConfig({ ...config, adId: 3 })
  pushMessages()
}
const changeDataPrice = () => {
  setConfig({ ...config, adId: 4 })
  pushMessages()
}
const changeDataRemove = () => {
  setConfig({ ...config, adId: 5 })
  pushMessages()
}
const noOffer = () => {
  setConfig({ ...config, adId: 6 })
  messageBus.publish('classified-innfinn-channel', 'pf-price', null)
  messageBus.publish('classified-innfinn-channel', 'pf-make', null)
  messageBus.publish('classified-innfinn-channel', 'pf-effect', null)
  messageBus.publish('classified-innfinn-channel', 'pf-mileage', null)
  messageBus.publish('classified-innfinn-channel', 'pf-year', null)
  messageBus.publish('classified-innfinn-channel', 'pf-first-registration', null)
}
const alreadySelectedOffer = () => {
  setConfig({ ...config, adId: 7 })
  messageBus.publish('classified-innfinn-channel', 'pf-price', null)
  messageBus.publish('classified-innfinn-channel', 'pf-make', null)
  messageBus.publish('classified-innfinn-channel', 'pf-effect', null)
  messageBus.publish('classified-innfinn-channel', 'pf-mileage', null)
  messageBus.publish('classified-innfinn-channel', 'pf-year', null)
  messageBus.publish('classified-innfinn-channel', 'pf-first-registration', null)
}

const modelAndMakeIdOffer = () => {
  setConfig({ ...config, adId: 238514267 })
  messageBus.publish('classified-innfinn-channel', 'pf-model-and-make-id', 1433)
  messageBus.publish('classified-innfinn-channel', 'pf-effect', 401)
  messageBus.publish('classified-innfinn-channel', 'pf-mileage', 25_000)
  messageBus.publish('classified-innfinn-channel', 'pf-year', 2018)
  messageBus.publish('classified-innfinn-channel', 'pf-first-registration', '2018-01-01')
}
</script>

<template>
  <section class="my-32 space-y-8 flex flex-col bg-yellow-100 p-16 rounded-4">
    <f-button @click="prepToCheckOffer">
      Prep to check offer
    </f-button>
    <f-button @click="prepToUncheckOffer">
      Prep to uncheck offer
    </f-button>
    <f-button @click="update">
      Update ad data
    </f-button>
    <f-button @click="changeDataPrice">
      Change data - cause price change
    </f-button>
    <f-button @click="changeDataRemove">
      Change data - remove offer
    </f-button>
    <f-button @click="noOffer">
      No offer
    </f-button>
    <f-button @click="alreadySelectedOffer">
      Already selected offer
    </f-button>
    <f-button @click="modelAndMakeIdOffer">
      Model and make id offer
    </f-button>
  </section>
</template>
